angular
	.module('inputPiva.components', [])
	.component('inputPiva', {
		templateUrl: 'ng/components/inputPiva/inputPiva.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			formName: '=',
			bindingVariable: '=',
			inputPlaceholder: '@',
			placeholder: '@',
			/** Optional data **/
			inputDisableOn: '<',
			inputRequired: '<',
			elementToDisable: '@',
			checkWholeForm: '@'
		},
		controllerAs: 'inputPivaCtrl',
		controller: function (es6Factory, validationService) {

			/** not to loose *this reference **/
			var self = this;

			self.valid = true;

			self.showAlertMsg = false;

			self.validationService = validationService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;
			}

			self.$onChanges = function () {

			}

			self.padPiWithZeros = function (pi) {
				if (pi && pi.length > 0) {
					var paddedPi = es6Factory.padWithZeros(pi, 10);
					console.log('paddedPi', paddedPi);
					self.bindingVariable = paddedPi;
					self.controllaPIVA(paddedPi);
				}
			}

			self.controllaPIVA = function (pi) {
				if (pi == '') {
					self.formName[self.inputName].$setValidity('piva', true);
					self.valid = true;
					return;
				}

				if (!validationService.isValidPiva(pi)) {
					//return "La partita IVA deve contenere 11 cifre.";
					self.formName[self.inputName].$setValidity('piva', false);
					self.valid = false;
					return;
				}

				//check carattere di controllo
				var s = 0;
				for (i = 0; i <= 9; i += 2)
					s += pi.charCodeAt(i) - '0'.charCodeAt(0);
				for (var i = 1; i <= 9; i += 2) {
					var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
					if (c > 9) c = c - 9;
					s += c;
				}
				var atteso = (10 - s % 10) % 10;
				if (atteso != pi.charCodeAt(10) - '0'.charCodeAt(0)) {
					//return "La partita IVA non è valida:\n" +
					//"il codice di controllo non corrisponde.\n";
					self.formName[self.inputName].$setValidity('piva', false);
					self.valid = false;
					return;
				}
				self.formName[self.inputName].$setValidity('piva', true);
				self.valid = true;
			}



			self.errorMsgShown = false;
			self.validationService = validationService;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

		}
	});